import Modal from '../Modal/modal';
import React from 'react';
import Title from '../Title/index';
import Text from '../Text/index';

const ToggleContent = () => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <>
      <button onClick={handleOpen} className="modal_btn">
        Отправить
      </button>
      <Modal isOpen={open} onClose={handleClose}>
        <div className="modal">
          <Title size="md">Ваше сообщение отправлено</Title>
          <Text section="modal" component="p">
            Благодарим Вас за потраченное время
          </Text>
        </div>
      </Modal>
    </>
  );
};

export default ToggleContent;
